import React from 'react';

/**
 * MenuForm component renders a form to submit menu data.
 * 
 * @param {function} onSubmit - Function to handle form submission.
 * @param {number} itemID - The ID of the item to associate with the form submission.
 * @returns {JSX.Element} A form element for submitting menu data.
 */
export function MenuForm({ onSubmit, itemID }) {

    /**
     * Handles the form submission event.
     */
    const handleSubmit = (event) => {
        event.preventDefault();

        const data = new FormData(event.target);
        data.append('menuChildren', JSON.stringify([])); // Add an empty array as a string

        onSubmit(data, itemID);
    };

    return (
        <div>
            <form onSubmit={handleSubmit} method="post" className="menu-form">
                <div className="form-group">
                    <label>Menytext</label>
                    <input name="menuText" type="text" className="form-control" id="menutext" placeholder="Skriv rubriken på nya menyn här." />
                </div>
                <button type="submit" className="btn btn-primary">Skapa</button>
            </form>
        </div>
    );
}
